import React from "react";
import { styled } from "styled-components";
const StyledTopMenuContent = styled.div `
  flex: 1 0 auto;
`;
export const TopMenuContent = ({ children }) => React.createElement(StyledTopMenuContent, null, children);
export default TopMenuContent;
//# sourceMappingURL=index.js.map